export interface DraftData {
  id: string;
  updated_at?: string | number;
  [key: string]: any;
}

export function lastWriteWins<T extends DraftData>(local: T, remote: T): T {
  const parseTime = (v: string | number | undefined) => {
    if (!v) return 0;
    if (typeof v === 'number') return v;
    const t = Date.parse(v);
    return isNaN(t) ? 0 : t;
  };

  const localTs = parseTime(local.updated_at) ||
    (typeof local.id === 'string' && local.id.startsWith('offline-')
      ? parseInt(local.id.slice(8), 10)
      : 0);
  const remoteTs = parseTime(remote.updated_at);
  return localTs >= remoteTs ? local : remote;
}
